
(() => {
  const SideDrawer = customElements.get('side-drawer');

  class CartDrawer extends SideDrawer {
    connectedCallback() {
      super.connectedCallback();
      this.syncTop();
      this.onTop = () => this.syncTop();
      window.addEventListener('resize', this.onTop);
      window.addEventListener('scroll', this.onTop, { passive: true });
      this.busy = false;

      this.addEventListener('click', (e) => {
        const step = e.target.closest('.quantityWrap .mines, .quantityWrap .plus');
        if (step) {
          e.preventDefault();
          this.step(step);
          return;
        }
        const btn = e.target.closest('[data-cart-remove]');
        if (btn) {
          e.preventDefault();
          this.changeLine(Number(btn.dataset.line), 0);
        }
      });

      this.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        const step = e.target.closest('.quantityWrap .mines, .quantityWrap .plus');
        if (!step) return;
        e.preventDefault();
        this.step(step);
      });

      this.addEventListener('change', (e) => {
        const input = e.target.closest('.quantityWrap input.quantity');
        if (!input) return;
        const value = Math.max(0, parseInt(input.value, 10) || 0);
        // Подарункові одиниці того самого рядка показані окремими картками,
        // а лічильник - лише платні; тож у кошик пишемо платні + подарункові.
        const offset = parseInt(input.dataset.offset, 10) || 0;
        this.changeLine(Number(input.dataset.line), value + offset);
      });

      /* ОДИН РЕНДЕР НА ВСІ ПЕРЕРАХУНКИ. Одна дія покупця тягне за собою
         ланцюжок змін кошика: сам товар, потім подарунок за таймером, потім
         драбина прибирає старі пробники й кладе нові. Якщо малювати кожну
         проміжну відповідь, список скаче 3-4 рази. Тому поки зміни йдуть, над
         списком крутиться серце (`.activeLoad`), а малюємо раз - коли кошик
         затих: ні запитів у польоті, ні утримань від драбини протягом 300 мс.
         Тоді беремо свіжу секцію - саме фінальний стан, а не останню з відповідей
         (частина з них приходить без HTML). */
      this.pending = 0;
      this.holds = 0;
      this.dirty = false;
      this.onRequest = () => { this.pending++; this.dirty = true; this.setLoading(true); clearTimeout(this.quietTimer); };
      this.onHold = () => { this.holds++; clearTimeout(this.quietTimer); };
      this.onRelease = () => { this.holds = Math.max(0, this.holds - 1); this.scheduleSettle(); };
      document.addEventListener('cart:request', this.onRequest);
      document.addEventListener('cart:hold', this.onHold);
      document.addEventListener('cart:release', this.onRelease);

      this.unsubscribe = window.PubSub.subscribe(window.EVENTS.cartUpdate, ({ sections, source }) => {
        this.pending = Math.max(0, this.pending - 1);
        const html = sections?.['cart-drawer'];
        /* «Свіжий» HTML - лише з НАЙОСТАННІШОЇ відповіді: тоді по секцію ще раз
           не ходимо. Відповідь без HTML робить його застарілим. */
        if (html) { this.lastHtml = html; this.dirty = true; }
        this.htmlFresh = Boolean(html);
        this.scheduleSettle();

        const SILENT = ['promo-gift', 'promo-gift-sync', 'promo-code', 'cart-page', 'cart-drawer', 'cart-options', 'cart-gift-timer', 'cart-ladder'];
        /* На сторінці кошика (/cart) кошик і так перед очима - шухляду не відкриваємо
           (напр. після «Додати подарункове пакування» з правої колонки). */
        if (!SILENT.includes(source) && !this.isOpen && !document.querySelector('cart-page.ckPage')) this.open();
      });

      this.unsubscribeErr = window.PubSub.subscribe(window.EVENTS.cartError, ({ message, source }) => {
        this.pending = Math.max(0, this.pending - 1);
        this.scheduleSettle();
        if (source !== 'cart-drawer') return;
        this.showError(message);
      });
    }

    setLoading(on) {
      this.querySelector('.cardWrapper')?.classList.toggle('activeLoad', on);
    }

    scheduleSettle() {
      clearTimeout(this.quietTimer);
      if (!this.dirty) return;
      this.quietTimer = setTimeout(() => this.settle(), 300);
    }

    async settle() {
      if (this.pending > 0 || this.holds > 0) return;
      let html = this.lastHtml;
      if (!html || !this.htmlFresh) {
        try {
          const res = await fetch(`${window.location.pathname}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
          const data = await res.json();
          if (data && data['cart-drawer']) html = data['cart-drawer'];
        } catch (_) {
          /* мережа підвела - малюємо останнє, що маємо */
        }
      }
      /* Поки чекали секцію, міг початися новий ланцюжок - тоді він і намалює. */
      if (this.pending > 0 || this.holds > 0) return;
      if (html) this.renderFrom(html);
      this.lastHtml = null;
      this.dirty = false;
      this.setLoading(false);
    }

    step(el) {
      const input = el.parentElement?.querySelector('input.quantity');
      if (!input) return;
      const current = parseInt(input.value, 10) || 0;
      const next = el.classList.contains('plus') ? current + 1 : current - 1;
      if (next < 0) return;
      const offset = parseInt(input.dataset.offset, 10) || 0;
      this.changeLine(Number(input.dataset.line), next + offset);
    }

    open(trigger) {
      super.open(trigger);
      this.syncTop();
    }

    // Верх панелі на мобілці - під смугою акції (макет 2182:20657). Коли
    // смугу прокрутили за екран, значення падає до 0 і панель на весь екран.
    syncTop() {
      const bar = document.querySelector('.siteTestBanner');
      const bottom = bar ? Math.round(bar.getBoundingClientRect().bottom) : 0;
      document.documentElement.style.setProperty('--cart-drawer-top', `${Math.max(0, bottom)}px`);
    }

    async changeLine(line, quantity) {
      if (this.busy || !line) return;
      this.busy = true;

      /* Серце вмикає сам запит (cart:request), а знімає settle(), коли кошик
         затихне - тут його не чіпаємо, інакше воно зникало б посеред ланцюжка. */
      try {
        await window.CartAPI.change({ line, quantity }, { source: 'cart-drawer' });
      } catch (_) {

      } finally {
        this.busy = false;
      }
    }

    renderFrom(sectionHtml) {
      const wrap = this.querySelector('.cardWrapper');
      if (!wrap) return;
      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const fresh = doc.querySelector('.cardWrapper');
      if (!fresh) return;

      if (wrap.classList.contains('activeLoad')) fresh.classList.add('activeLoad');
      wrap.replaceWith(fresh);
    }

    showError(message) {
      const box = this.querySelector('[data-cart-drawer-error]');
      if (!box) return;
      box.textContent = message;
      box.removeAttribute('hidden');
      clearTimeout(this.errTimer);
      this.errTimer = setTimeout(() => box.setAttribute('hidden', ''), 4000);
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      if (this.onTop) {
        window.removeEventListener('resize', this.onTop);
        window.removeEventListener('scroll', this.onTop);
      }
      this.unsubscribe?.();
      this.unsubscribeErr?.();
      document.removeEventListener('cart:request', this.onRequest);
      document.removeEventListener('cart:hold', this.onHold);
      document.removeEventListener('cart:release', this.onRelease);
      clearTimeout(this.quietTimer);
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
})();
